import React from "react";

const MAP = {
  PENDING_APPROVAL: "bg-orange-100 text-orange-800 border-orange-300",
  APPROVED: "bg-blue-100 text-blue-800 border-blue-300",
  PHOTO_CAPTURED: "bg-indigo-100 text-indigo-800 border-indigo-300",
  ISSUED: "bg-green-100 text-green-800 border-green-300",
  DARSHAN_COMPLETED: "bg-emerald-100 text-emerald-900 border-emerald-300",
  SOLD: "bg-pink-100 text-pink-800 border-pink-300",
  GODOWN_IN: "bg-blue-100 text-blue-800 border-blue-300",
  GODOWN_OUT: "bg-purple-100 text-purple-800 border-purple-300",
  REJECTED: "bg-red-100 text-red-800 border-red-300",
  CANCELLED: "bg-slate-200 text-slate-700 border-slate-300",
  ACTIVE: "bg-green-100 text-green-800 border-green-300",
  INACTIVE: "bg-slate-200 text-slate-600 border-slate-300",
};

// Saree tokens keep the stored status ISSUED; on saree screens it reads RECEIVING.
export const sareeStatusLabel = (status) => (status === "ISSUED" ? "RECEIVING" : (status || "").replace(/_/g, " "));

export default function StatusBadge({ status, saree = false }) {
  return (
    <span
      data-testid={`status-badge-${(status || "").toLowerCase()}`}
      className={`inline-block px-2 py-0.5 rounded border text-[11px] font-bold tracking-wide ${MAP[status] || "bg-slate-100 text-slate-700 border-slate-300"}`}
    >
      {saree ? sareeStatusLabel(status) : (status || "").replace(/_/g, " ")}
    </span>
  );
}
